import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import InvoicesCtrl from '@webapp/controllers/artist/artist-billing/invoices';
import ButtonLoadingFixedCtrl from '@webapp/controllers/button-loading-fixed';
import CreditCardCtrl from '@webapp/controllers/artist/artist-billing/credit-card';
import CurrentPlanCtrl from '@webapp/controllers/artist/artist-billing/current-plan';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

interface ArtistProfileFinancialPageProps {
  className?: string;
}

export const ArtistProfileFinancialPage: React.FC<ArtistProfileFinancialPageProps> = (
  props
) => {
  return (
    <MotionOpacity className={props.className}>
      <Typography className="mb-20" type="subheader" weight="400">
        <Translate id="ARTIST_PROFILE.BILLING.TITLE" />
      </Typography>
      <CurrentPlanCtrl className="mb-50" />

      <CreditCardCtrl className="mb-50" />

      <InvoicesCtrl className="mb-50" />

      <ButtonLoadingFixedCtrl small isLoading={false} onClick={() => null}>
        Save Settings
      </ButtonLoadingFixedCtrl>
    </MotionOpacity>
  );
};

export default styled(ArtistProfileFinancialPage)``;
